export const TellerAbi = [
  {
    inputs: [
      { internalType: "address", name: "_owner", type: "address" },
      { internalType: "address", name: "_vault", type: "address" },
      { internalType: "address", name: "_accountant", type: "address" },
      { internalType: "address", name: "_endpoint", type: "address" },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  { inputs: [], name: "InvalidDelegate", type: "error" },
  { inputs: [], name: "InvalidEndpointCall", type: "error" },
  {
    inputs: [{ internalType: "uint16", name: "optionType", type: "uint16" }],
    name: "InvalidOptionType",
    type: "error",
  },
  { inputs: [], name: "LzTokenUnavailable", type: "error" },
  {
    inputs: [],
    name: "MultiChainLayerZeroTellerWithMultiAssetSupport_InvalidToken",
    type: "error",
  },
  {
    inputs: [],
    name: "MultiChainTellerBase_DestinationChainReceiverIsZeroAddress",
    type: "error",
  },
  { inputs: [], name: "MultiChainTellerBase_GasLimitExceeded", type: "error" },
  { inputs: [], name: "MultiChainTellerBase_GasTooLow", type: "error" },
  {
    inputs: [{ internalType: "uint32", name: "chainSelector", type: "uint32" }],
    name: "MultiChainTellerBase_MessagesNotAllowedFrom",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint256", name: "chainSelector", type: "uint256" },
    ],
    name: "MultiChainTellerBase_MessagesNotAllowedTo",
    type: "error",
  },
  {
    inputs: [],
    name: "MultiChainTellerBase_TargetTellerIsZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "MultiChainTellerBase_ZeroMessageGasLimit",
    type: "error",
  },
  {
    inputs: [{ internalType: "uint32", name: "eid", type: "uint32" }],
    name: "NoPeer",
    type: "error",
  },
  {
    inputs: [{ internalType: "uint256", name: "msgValue", type: "uint256" }],
    name: "NotEnoughNative",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "addr", type: "address" }],
    name: "OnlyEndpoint",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint32", name: "eid", type: "uint32" },
      { internalType: "bytes32", name: "sender", type: "bytes32" },
    ],
    name: "OnlyPeer",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint8", name: "bits", type: "uint8" },
      { internalType: "uint256", name: "value", type: "uint256" },
    ],
    name: "SafeCastOverflowedUintDowncast",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "token", type: "address" }],
    name: "SafeERC20FailedOperation",
    type: "error",
  },
  {
    inputs: [],
    name: "TellerWithMultiAssetSupport__AssetNotSupported",
    type: "error",
  },
  {
    inputs: [],
    name: "TellerWithMultiAssetSupport__BadDepositHash",
    type: "error",
  },
  {
    inputs: [],
    name: "TellerWithMultiAssetSupport__MinimumAssetsNotMet",
    type: "error",
  },
  {
    inputs: [],
    name: "TellerWithMultiAssetSupport__MinimumMintNotMet",
    type: "error",
  },
  { inputs: [], name: "TellerWithMultiAssetSupport__Paused", type: "error" },
  {
    inputs: [],
    name: "TellerWithMultiAssetSupport__PermitFailedAndAllowanceTooLow",
    type: "error",
  },
  {
    inputs: [],
    name: "TellerWithMultiAssetSupport__ShareLockPeriodTooLong",
    type: "error",
  },
  {
    inputs: [],
    name: "TellerWithMultiAssetSupport__SharesAreLocked",
    type: "error",
  },
  {
    inputs: [],
    name: "TellerWithMultiAssetSupport__SharesAreUnLocked",
    type: "error",
  },
  {
    inputs: [],
    name: "TellerWithMultiAssetSupport__ZeroAssets",
    type: "error",
  },
  {
    inputs: [],
    name: "TellerWithMultiAssetSupport__ZeroShares",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
    ],
    name: "AssetAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
    ],
    name: "AssetRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "user", type: "address" },
      {
        indexed: true,
        internalType: "contract Authority",
        name: "newAuthority",
        type: "address",
      },
    ],
    name: "AuthorityUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "depositAmount",
        type: "uint256",
      },
    ],
    name: "BulkDeposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shareAmount",
        type: "uint256",
      },
    ],
    name: "BulkWithdraw",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "chainSelector",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "allowMessagesFrom",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "allowMessagesTo",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetTeller",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "messageGasLimit",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "messageGasMin",
        type: "uint64",
      },
    ],
    name: "ChainAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "chainSelector",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetTeller",
        type: "address",
      },
    ],
    name: "ChainAllowMessagesFrom",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "chainSelector",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "targetTeller",
        type: "address",
      },
    ],
    name: "ChainAllowMessagesTo",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "chainSelector",
        type: "uint256",
      },
    ],
    name: "ChainRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "chainSelector",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "messageGasLimit",
        type: "uint64",
      },
    ],
    name: "ChainSetGasLimit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "chainSelector",
        type: "uint256",
      },
    ],
    name: "ChainStopMessagesFrom",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "chainSelector",
        type: "uint256",
      },
    ],
    name: "ChainStopMessagesTo",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "depositAsset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "depositAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shareAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "depositTimestamp",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shareLockPeriodAtTimeOfDeposit",
        type: "uint256",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "depositHash",
        type: "bytes32",
      },
      { indexed: true, internalType: "address", name: "user", type: "address" },
    ],
    name: "DepositRefunded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "messageId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shareAmount",
        type: "uint256",
      },
      { indexed: false, internalType: "address", name: "to", type: "address" },
    ],
    name: "MessageReceived",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "messageId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shareAmount",
        type: "uint256",
      },
      { indexed: false, internalType: "address", name: "to", type: "address" },
    ],
    name: "MessageSent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "user", type: "address" },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  { anonymous: false, inputs: [], name: "Paused", type: "event" },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint32", name: "eid", type: "uint32" },
      {
        indexed: false,
        internalType: "bytes32",
        name: "peer",
        type: "bytes32",
      },
    ],
    name: "PeerSet",
    type: "event",
  },
  { anonymous: false, inputs: [], name: "Unpaused", type: "event" },
  {
    inputs: [],
    name: "accountant",
    outputs: [
      {
        internalType: "contract AccountantWithRateProviders",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "contract ERC20", name: "asset", type: "address" },
    ],
    name: "addAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint32", name: "chainSelector", type: "uint32" },
      { internalType: "bool", name: "allowMessagesFrom", type: "bool" },
      { internalType: "bool", name: "allowMessagesTo", type: "bool" },
      { internalType: "address", name: "targetTeller", type: "address" },
      { internalType: "uint64", name: "messageGasLimit", type: "uint64" },
      { internalType: "uint64", name: "messageGasMin", type: "uint64" },
    ],
    name: "addChain",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "srcEid", type: "uint32" },
          { internalType: "bytes32", name: "sender", type: "bytes32" },
          { internalType: "uint64", name: "nonce", type: "uint64" },
        ],
        internalType: "struct Origin",
        name: "origin",
        type: "tuple",
      },
    ],
    name: "allowInitializePath",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint32", name: "chainSelector", type: "uint32" },
      { internalType: "address", name: "targetTeller", type: "address" },
    ],
    name: "allowMessagesFromChain",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint32", name: "chainSelector", type: "uint32" },
      { internalType: "address", name: "targetTeller", type: "address" },
      { internalType: "uint64", name: "messageGasLimit", type: "uint64" },
    ],
    name: "allowMessagesToChain",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "authority",
    outputs: [
      { internalType: "contract Authority", name: "", type: "address" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "from", type: "address" }],
    name: "beforeTransfer",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "shareAmount", type: "uint256" },
      {
        components: [
          { internalType: "uint32", name: "chainSelector", type: "uint32" },
          {
            internalType: "address",
            name: "destinationChainReceiver",
            type: "address",
          },
          {
            internalType: "contract ERC20",
            name: "bridgeFeeToken",
            type: "address",
          },
          { internalType: "uint64", name: "messageGas", type: "uint64" },
          { internalType: "bytes", name: "data", type: "bytes" },
        ],
        internalType: "struct BridgeData",
        name: "data",
        type: "tuple",
      },
    ],
    name: "bridge",
    outputs: [{ internalType: "bytes32", name: "messageId", type: "bytes32" }],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "contract ERC20", name: "depositAsset", type: "address" },
      { internalType: "uint256", name: "depositAmount", type: "uint256" },
      { internalType: "uint256", name: "minimumMint", type: "uint256" },
      { internalType: "address", name: "to", type: "address" },
    ],
    name: "bulkDeposit",
    outputs: [{ internalType: "uint256", name: "shares", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ERC20",
        name: "withdrawAsset",
        type: "address",
      },
      { internalType: "uint256", name: "shareAmount", type: "uint256" },
      { internalType: "uint256", name: "minimumAssets", type: "uint256" },
      { internalType: "address", name: "to", type: "address" },
    ],
    name: "bulkWithdraw",
    outputs: [{ internalType: "uint256", name: "assetsOut", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "contract ERC20", name: "depositAsset", type: "address" },
      { internalType: "uint256", name: "depositAmount", type: "uint256" },
      { internalType: "uint256", name: "minimumMint", type: "uint256" },
    ],
    name: "deposit",
    outputs: [{ internalType: "uint256", name: "shares", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "contract ERC20", name: "depositAsset", type: "address" },
      { internalType: "uint256", name: "depositAmount", type: "uint256" },
      { internalType: "uint256", name: "minimumMint", type: "uint256" },
      {
        components: [
          { internalType: "uint32", name: "chainSelector", type: "uint32" },
          {
            internalType: "address",
            name: "destinationChainReceiver",
            type: "address",
          },
          {
            internalType: "contract ERC20",
            name: "bridgeFeeToken",
            type: "address",
          },
          { internalType: "uint64", name: "messageGas", type: "uint64" },
          { internalType: "bytes", name: "data", type: "bytes" },
        ],
        internalType: "struct BridgeData",
        name: "data",
        type: "tuple",
      },
    ],
    name: "depositAndBridge",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "depositNonce",
    outputs: [{ internalType: "uint96", name: "", type: "uint96" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "contract ERC20", name: "depositAsset", type: "address" },
      { internalType: "uint256", name: "depositAmount", type: "uint256" },
      { internalType: "uint256", name: "minimumMint", type: "uint256" },
      { internalType: "uint256", name: "deadline", type: "uint256" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" },
    ],
    name: "depositWithPermit",
    outputs: [{ internalType: "uint256", name: "shares", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "endpoint",
    outputs: [
      {
        internalType: "contract ILayerZeroEndpointV2",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "srcEid", type: "uint32" },
          { internalType: "bytes32", name: "sender", type: "bytes32" },
          { internalType: "uint64", name: "nonce", type: "uint64" },
        ],
        internalType: "struct Origin",
        name: "",
        type: "tuple",
      },
      { internalType: "bytes", name: "", type: "bytes" },
      { internalType: "address", name: "_sender", type: "address" },
    ],
    name: "isComposeMsgSender",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isPaused",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "contract ERC20", name: "", type: "address" }],
    name: "isSupported",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "srcEid", type: "uint32" },
          { internalType: "bytes32", name: "sender", type: "bytes32" },
          { internalType: "uint64", name: "nonce", type: "uint64" },
        ],
        internalType: "struct Origin",
        name: "_origin",
        type: "tuple",
      },
      { internalType: "bytes32", name: "_guid", type: "bytes32" },
      { internalType: "bytes", name: "_message", type: "bytes" },
      { internalType: "address", name: "_executor", type: "address" },
      { internalType: "bytes", name: "_extraData", type: "bytes" },
    ],
    name: "lzReceive",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint32", name: "", type: "uint32" },
      { internalType: "bytes32", name: "", type: "bytes32" },
    ],
    name: "nextNonce",
    outputs: [{ internalType: "uint64", name: "nonce", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "oAppVersion",
    outputs: [
      { internalType: "uint64", name: "senderVersion", type: "uint64" },
      { internalType: "uint64", name: "receiverVersion", type: "uint64" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint32", name: "eid", type: "uint32" }],
    name: "peers",
    outputs: [{ internalType: "bytes32", name: "peer", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "shareAmount", type: "uint256" },
      {
        components: [
          { internalType: "uint32", name: "chainSelector", type: "uint32" },
          {
            internalType: "address",
            name: "destinationChainReceiver",
            type: "address",
          },
          {
            internalType: "contract ERC20",
            name: "bridgeFeeToken",
            type: "address",
          },
          { internalType: "uint64", name: "messageGas", type: "uint64" },
          { internalType: "bytes", name: "data", type: "bytes" },
        ],
        internalType: "struct BridgeData",
        name: "data",
        type: "tuple",
      },
    ],
    name: "previewFee",
    outputs: [{ internalType: "uint256", name: "fee", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "publicDepositHistory",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "nonce", type: "uint256" },
      { internalType: "address", name: "receiver", type: "address" },
      { internalType: "address", name: "depositAsset", type: "address" },
      { internalType: "uint256", name: "depositAmount", type: "uint256" },
      { internalType: "uint256", name: "shareAmount", type: "uint256" },
      { internalType: "uint256", name: "depositTimestamp", type: "uint256" },
      {
        internalType: "uint256",
        name: "shareLockUpPeriodAtTimeOfDeposit",
        type: "uint256",
      },
    ],
    name: "refundDeposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "contract ERC20", name: "asset", type: "address" },
    ],
    name: "removeAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint32", name: "chainSelector", type: "uint32" }],
    name: "removeChain",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint32", name: "", type: "uint32" }],
    name: "selectorToChains",
    outputs: [
      { internalType: "bool", name: "allowMessagesFrom", type: "bool" },
      { internalType: "bool", name: "allowMessagesTo", type: "bool" },
      { internalType: "address", name: "targetTeller", type: "address" },
      { internalType: "uint64", name: "messageGasLimit", type: "uint64" },
      { internalType: "uint64", name: "minimumMessageGas", type: "uint64" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract Authority",
        name: "newAuthority",
        type: "address",
      },
    ],
    name: "setAuthority",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint32", name: "chainSelector", type: "uint32" },
      { internalType: "uint64", name: "messageGasLimit", type: "uint64" },
    ],
    name: "setChainGasLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_delegate", type: "address" }],
    name: "setDelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint32", name: "_eid", type: "uint32" },
      { internalType: "bytes32", name: "_peer", type: "bytes32" },
    ],
    name: "setPeer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint64", name: "_shareLockPeriod", type: "uint64" },
    ],
    name: "setShareLockPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "shareLockPeriod",
    outputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "shareUnlockTime",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint32", name: "chainSelector", type: "uint32" }],
    name: "stopMessagesFromChain",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint32", name: "chainSelector", type: "uint32" }],
    name: "stopMessagesToChain",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "vault",
    outputs: [
      { internalType: "contract BoringVault", name: "", type: "address" },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;
